import { h } from 'preact';
import { useState } from 'preact/hooks';
import VariantSelector from '../product/variant-selector';
import AddToCartButton from '../product/add-to-cart-button';

const DonationsProduct = ({ donationProduct }) => {
  const [selectedVariant, setSelectedVariant] = useState(donationProduct.variants[0]);
  const [showLegalCopy, setShowLegalCopy] = useState(false);

  const handleVariantChange = (variant) => {
    setSelectedVariant(variant);
  };

  const handleAddToCart = (e) => {
    e.preventDefault();

    // Initialize the payload
    const payload = {
      merchandiseId: selectedVariant.id,
      quantity: 1,
      attributes: [
        {
          key: '_inventoryManagement',
          value: selectedVariant.inventoryManagement,
        },
        {
          key: '_inventoryPolicy',
          value: selectedVariant.inventoryPolicy,
        },
      ],
    };

    // Check if requiresShipping exists and is false
    if (selectedVariant.requiresShipping === false) {
      payload.attributes.push({ key: '_electronic', value: 'true' });
    }

    // Dispatch the custom event
    const addToCartEvent = new CustomEvent('cart:add', {
      detail: { payload },
    });

    document.dispatchEvent(addToCartEvent);
  };

  const handleToggleLegalCopy = () => {
    setShowLegalCopy(!showLegalCopy);
  };

  return (
    <div className="donation-product flex flex-col gap-12 bg-grey-6 p-20">
      <h4 className="body-16-med text-primary">{donationProduct.donationProductTitle}</h4>
      <p className="body-12-light text-primary">{donationProduct.donationProductDescription}</p>
      <div className="flex gap-12">
        {donationProduct.options.map((option) => (
          <VariantSelector
            key={option.name}
            product={donationProduct}
            currentVariant={selectedVariant}
            option={option}
            setCurrentVariant={handleVariantChange}
            filteredVariants={donationProduct.variants}
          />
        ))}
        <AddToCartButton
          currentVariant={selectedVariant}
          handleAddToCart={handleAddToCart}
          checkedOptions={{ size: true, weight: true }}
          isGiftCard={false}
          isDonationCard={true}
        />
      </div>
      <p
        className="body-10-light donation-legal-cta cursor-pointer text-primary underline"
        onClick={handleToggleLegalCopy}
      >
        {donationProduct.donationLegalCta}
      </p>
      <p className={`body-10-light donation-legal-copy ${showLegalCopy ? '' : 'hidden'} text-primary`}>
        {donationProduct.donationLegalCopy}
      </p>
    </div>
  );
};

export default DonationsProduct;
